export default "__VITE_ASSET__CNaeCnQT__"